import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation, navigate } from "@reach/router";
import { useAuthContext } from "contexts";
import { SUPER_USER_TABS, MODERATOR_TABS, ACTIVE_USER_TABS } from "config";
import { IconButton } from "components";
import { ProfileModal } from "modals";
import { useModal } from "hooks";
import { abbreviateName } from "utils";
import { Link } from "@reach/router";
//import { IoMdNotifications } from "react-icons/io";

export const Header = ({ props, active = "" }) => {
  const location = useLocation();
  const [viewName, setViewName] = useState("");
  const profileModal = useModal();
  //const alertsModal = useModal();
  const { userInfo } = useAuthContext();

  const handleNavigateToHome = () => {
    navigate("/home");
  };

  const handleLogoClick = (event) => {
    if (event.button === 1) {
      window.open("/home");
    }
  };

  useEffect(() => {
    const pathSplit = location.pathname.split("/");
    var name = pathSplit[1];
    if (pathSplit.length === 2 && pathSplit[1] === "circular") {
      name = "Circulars";
    }
    setViewName(name);
  }, [location]);

  return (
    <StyledHeader>
      <HeaderContent>
        <LogoSection>
          <Logo
            onMouseDown={handleLogoClick}
            onClick={handleNavigateToHome}
          >
            ADDISON
          </Logo>

          {viewName && <ViewName>{viewName}</ViewName>}
        </LogoSection>

        <NavSection>
          {userInfo.user?.is_superuser ?
            SUPER_USER_TABS.map(({ label, url }) => (
              <NavLink key={label} to={url} active={label.toUpperCase() === viewName?.toUpperCase()}>
                {label}
              </NavLink>
            ))
            : userInfo.user?.is_moderator ?
              MODERATOR_TABS.map(({ label, url }) => (
                <NavLink key={label} to={url} active={label.toUpperCase() === viewName?.toUpperCase()}>
                  {label}
                </NavLink>
              ))
              : userInfo.user?.is_active ?
                ACTIVE_USER_TABS.map(({ label, url }) => (
                  <NavLink key={label} to={url} active={label.toUpperCase() === viewName?.toUpperCase()}>
                    {label}
                  </NavLink>
                )) : null}
          <ProfileButton
            onClick={() => profileModal.openModal()}
            text={abbreviateName(userInfo?.user?.username)}
            avatar={userInfo?.avatar}
          />
        </NavSection>
      </HeaderContent>
      <ProfileModal {...profileModal} userName={userInfo?.user?.username} />
      {/* <AlertsModal {...alertsModal} /> */}
    </StyledHeader>
  );
};

const StyledHeader = styled.div`
  background: ${(props) => props.theme.palette.backgrounds};
  height: 64px;
  width: 100%;
  display: flex;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
  min-width: 1660px;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;
  margin: 0 auto;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.div`
  font-weight: 500;
  cursor: pointer;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: -0.5px;
  padding: 8px 0;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

const ViewName = styled.span`
  position: relative;
  margin-left: 13px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  font-weight: 400;
  
  &:before {
    content: '/';
    position: absolute;
    left: -8px;
    color: rgba(255, 255, 255, 0.3);
  }
`;

const NavSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const NavLink = styled(Link)`
  color: ${(props) => props.active ? '#fff' : 'rgba(255, 255, 255, 0.6)'};
  border: 1px solid transparent;
  border-color: ${(props) => props.active ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  font-size: 14px;
  margin-right: 20px;
  text-decoration: none;
  transition: color 0.2s ease;
  padding: 6px 12px;
  border-radius: 6px;
  position: relative;
  background: ${(props) => 
    props.active ? 'rgba(255, 255, 255, 0.05)' : 'transparent'};
  
  &:hover {
    color: rgba(255, 255, 255, 0.77);
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.1);
    text-decoration: none;
  }
`;

const ProfileButton = styled(IconButton)`
  margin-left: 8px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  transition: all 0.3s ease;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #4b0082, #9400d3, #0000ff, #800080, #4b0082);
    background-size: 300% 300%;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
    opacity: 0.2;
    animation: cosmicShift 8s ease infinite;
  }
  
  &:hover {
    border-color: transparent;
    box-shadow: 0 0 10px rgba(148, 0, 211, 0.4);
    
    &:before {
      opacity: 0.85;
      animation: cosmicShift 3s ease infinite;
    }
  }
  
  @keyframes cosmicShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;
